export const columns = [
  {
    field: "name",
    header: "Delivery type",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "name")} className="">
          <p className="w-[6rem] cursor-pointer">{row?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "factor",
    header: "Factor",
    accessor: (row, handleCellClick) => (
      <>
        <table onClick={() => handleCellClick(row, "factor")} className="">
          <tr>
            <th className="te"> Factor</th>
            <th> Value</th>
          </tr>
          {row?.factor?.map((item) => (
            <tr className="">
              <td className="w-[6rem]">{item?.name || ""}</td>
              <td className="w-[6rem]">{item?.value || ""}</td>
            </tr>
          ))}
        </table>
      </>
    ),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};
